/* DillySocks — Produktsuche (Shopify Predictive Search, suggest.json).

   EINE Suchlogik fuer alle Oberflaechen: Header-Suche (Desktop + Mobile,
   snippets/ds-search-suggest.liquid) und der Bundle-Picker "Weiteres Design
   hinzufuegen" (ds-pdp-bundle.js). Enthaelt Debounce (180 ms), die
   Feld-Liste (auch Tags/Beschreibung — Sean 09.08.: Farben/Muster aus den
   Metafeldern sind als Tags gespiegelt) und den Schutz vor veralteten
   Antworten (nur anwenden, wenn die Eingabe noch aktuell ist).

   window.dsSearch.query(q, limit)        -> Promise<Produkt[]> (Predictive, max 10)
   window.dsSearch.bindInput(input, { onResults(products, q) | onQuery(q), onClear(), onInput(q) })
   window.dsSearch.searchPage(q, page)    -> { handles, next } (Storefront-Suche, 12/Seite)
   window.dsSearch.collectionPage(h, page)-> { handles, next } (Kollektion, 12/Seite)

   Kein Modul (Header-Snippet ist klassisch); guard gegen Doppel-Laden. */
(function () {
  'use strict';
  if (window.dsSearch) return;

  var DEBOUNCE_MS = 180;
  var FIELDS = 'title,tag,body,product_type,vendor';
  var ROOT = (window.DS_MARKET && window.DS_MARKET.root) || '';

  function query(q, limit) {
    var url =
      ROOT +
      '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + (limit || 10) +
      '&resources[options][unavailable_products]=hide' +
      '&resources[options][fields]=' + FIELDS;
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        return (d.resources && d.resources.results && d.resources.results.products) || [];
      });
  }

  function bindInput(input, opts) {
    if (!input || input.dataset.dsLive) return;
    input.dataset.dsLive = '1';
    opts = opts || {};
    var t;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(t);
      if (typeof opts.onInput === 'function') opts.onInput(q);
      if (!q) {
        if (typeof opts.onClear === 'function') opts.onClear();
        return;
      }
      t = setTimeout(function () {
        /* onQuery: Aufrufer holt sich die Treffer selbst (z.B. seitenweise
           per searchPage) — nur Debounce + Eingabe-Aktualitaet von hier. */
        if (typeof opts.onQuery === 'function') { opts.onQuery(q); return; }
        query(q, opts.limit)
          .then(function (prods) {
            if (input.value.trim() !== q) return; /* veraltet */
            if (typeof opts.onResults === 'function') opts.onResults(prods, q);
          })
          .catch(function () { /* Netzfehler: bisherige Anzeige stehen lassen */ });
      }, DEBOUNCE_MS);
    });
  }

  /* Seitenweise Treffer-Handles (Infinite Scroll im Bundle-Picker):
     dieselbe Storefront-Suche wie /search, ueber das schlanke Template
     templates/search.ds-handles.liquid (12 pro Seite, nur verfuegbare).
     -> Promise<{ handles: string[], next: boolean }> */
  var PAGE_SIZE = 12;
  function searchPage(q, page) {
    var url = ROOT + '/search?view=ds-handles&type=product&q=' + encodeURIComponent(q) + '&page=' + (page || 1);
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) { return { handles: d.handles || [], next: !!d.next }; });
  }

  /* Seitenweise Handles einer Kollektion (Quick-Links / Bestseller):
     Shopify-eigener JSON-Endpoint, gleiche Seitengroesse. */
  function collectionPage(handle, page) {
    var url = ROOT + '/collections/' + handle + '/products.json?limit=' + PAGE_SIZE + '&page=' + (page || 1);
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d.products || []).filter(function (p) {
          return (p.variants || []).some(function (v) { return v.available; });
        });
        return { handles: prods.map(function (p) { return p.handle; }), next: (d.products || []).length === PAGE_SIZE };
      });
  }

  window.dsSearch = {
    query: query,
    bindInput: bindInput,
    searchPage: searchPage,
    collectionPage: collectionPage,
    DEBOUNCE_MS: DEBOUNCE_MS,
    PAGE_SIZE: PAGE_SIZE,
  };
})();
